"use strict";
exports.__esModule = true;
var validateLength = function (value, maxLength, name) {
    var valueEndsWithOne = String(maxLength).endsWith('1') && !String(maxLength).endsWith('11');
    if (value.length > maxLength) {
        return name + " \u043D\u0435 \u043C\u043E\u0436\u0435\u0442 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0442\u044C \u0431\u043E\u043B\u0435\u0435 " + maxLength + " \u0441\u0438\u043C\u0432\u043E\u043B" + (valueEndsWithOne ? 'а' : 'ов');
    }
    return '';
};
exports["default"] = validateLength;
